import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        landing: false,
        webUser: {
            name: '',
            username: '',
            phoneNumber: '',
            email: '',
            hospital: '',
            level: ''
        }
    },
    mutations: {
        setLanding(state, landing){
            state.landing = landing;
        },
        setWebUser(state, webUser){
            state.webUser = webUser;
        },
        clearWebUser(state){
            state.webUser.name = '';
            state.webUser.username = '';
            state.webUser.phoneNumber = '';
            state.webUser.email = '';
            state.webUser.hospital = '';
            state.webUser.level = '';
        }
    },
    actions: {},
    modules: {}
})
